import React from "react";
import { getCumulativeSum } from "./accounting-helper";
import { currency } from "./common-helper";

const currencySymbol = currency();
export class SaleSummaryModel {
  label: string;
  amount: number | string;

  highligthLabel = false;
  extraSpace = false;

  constructor(label: any, amount: string) {
    this.label = label;
    this.amount = this.getValue(amount || 0);
  }

  private getValue(amount: any) {
    if (amount) {
      return Number(amount).toFixed(2);
    }
    return "0.00";
  }

  setHighligthLabel(isHighligthLabel: boolean) {
    this.highligthLabel = isHighligthLabel;
  }

  setExtraSpace(isExtraSpace: boolean) {
    this.extraSpace = isExtraSpace;
  }
}

export function renderSaleSummaryLeftHeader(brandsDataMap: any): React.JSX.Element{
  return(
    <div className="flex border-b-[1px] bg-white py-15">
    <div className="bg-white pl-20 pr-15 border-r-[1px] basis-1/3">
      <span className="text-[#0000007A] text-14 font-normal whitespace-nowrap">
        Sale Revenue
      </span>
      <br />
      <span className="text-black font-semibold">
        <span className="ml-2 text-17">
          {currencySymbol}
          {Number(
            getCumulativeSum(brandsDataMap, "grossSaleAmount")
          ).toFixed(2)}
        </span>
      </span>
    </div>
    <div className="bg-white pl-20 pr-15 border-r-[1px] basis-1/3">
      <span className="text-[#0000007A] text-14 font-normal whitespace-nowrap">
        Net Revenue
      </span>
      <br />
      <span className="text-black font-semibold">
        <span className="ml-2 text-17">
          {currencySymbol}
          {Number(
            getCumulativeSum(brandsDataMap, "netSaleAmount")
          ).toFixed(2)}
        </span>
      </span>
    </div>
    <div className="bg-white pl-20 pr-15 basis-1/3">
      <span className="text-[#0000007A] text-14 font-normal whitespace-nowrap">
        Orders
      </span>
      <br />
      <span className="ml-2 text-17 font-semibold">
        {getCumulativeSum(brandsDataMap, "saleCount")}
      </span>
    </div>
  </div>
  )
}

export function renderGroupByBranch(
  brand: any,
  isSelected: boolean,
  businessBranchesDataMap: any
): React.JSX.Element {
  return (
    <div className="flex flex-col w-[100%]">
      <div className="flex !justify-between pr-10">
        <div
          className={`text-[15px] capitalize ${
            isSelected ? "font-semibold" : ""
          }`}
        >
          {businessBranchesDataMap[brand?.branchId]?.branchName ||
            brand?.bizBrandName}
        </div>
        <div className="text-[14px] text-[#3A5E8B]">
          <span>Net Revenue:</span>
          <span className="ml-5 font-semibold">
            {currencySymbol}{Number(brand.netSaleAmount).toFixed(2)}
          </span>
        </div>
      </div>
      <div className="flex !justify-between pr-10">
        <div className={`text-[13px] text-[#0000007A]`}>
          <span>{brand.saleCount}</span>
          <span className="ml-2">Orders</span>
        </div>
        <div className="text-[13px] text-[#0000007A]">
          <span>Sales Item Revenue:</span>
          <span className="text-[#000000B2] ml-5">
            {currencySymbol}{Number(brand.grossSaleAmount).toFixed(2)}
          </span>
        </div>
      </div>
    </div>
  );
}
